module.exports = __webpack_public_path__ + "static/media/checkbox-unchecked.7f6ef2cb.svg";